import React from "react";
import { chefInfo } from "../../mock";
import { Mail, Instagram, MapPin, Phone, MessageCircle } from "lucide-react";

const iconClass =
  "w-11 h-11 border border-neutral-700 flex items-center justify-center group-hover:bg-[#fbf3e4] group-hover:text-neutral-900 transition-colors";

export default function ContactInfo() {
  return (
    <div>
      <p className="text-xs tracking-[0.4em] text-neutral-400 mb-4">CONTACT</p>
      <h3 className="font-display text-4xl md:text-6xl leading-[1]">Find out how I can help...</h3>
      <p className="mt-6 text-neutral-300 text-lg leading-relaxed max-w-md">
        Get in touch for a private dinner, wedding or corporate event. Let's create a bespoke experience together.
      </p>

      <div className="mt-10 space-y-5">
        <a href={`mailto:${chefInfo.email}`} className="flex items-center gap-4 group">
          <span className={iconClass}><Mail size={18} /></span>
          <span className="nav-link text-neutral-100">{chefInfo.email}</span>
        </a>
        <a href={`tel:${chefInfo.phone.replace(/\s/g, "")}`} className="flex items-center gap-4 group">
          <span className={iconClass}><Phone size={18} /></span>
          <span className="nav-link text-neutral-100">{chefInfo.phone}</span>
        </a>
        <a
          href={`https://wa.me/${chefInfo.whatsapp}`}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-4 group"
        >
          <span className={iconClass}><MessageCircle size={18} /></span>
          <span className="nav-link text-neutral-100">WhatsApp — 07443 667570</span>
        </a>
        <a
          href={chefInfo.instagram}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-4 group"
        >
          <span className={iconClass}><Instagram size={18} /></span>
          <span className="nav-link text-neutral-100">{chefInfo.instagramHandle}</span>
        </a>
        <div className="flex items-center gap-4">
          <span className="w-11 h-11 border border-neutral-700 flex items-center justify-center">
            <MapPin size={18} />
          </span>
          <span className="text-neutral-300">Stoke-on-Trent, Manchester and surrounding areas, UK</span>
        </div>
      </div>
    </div>
  );
}
